import { render, staticRenderFns } from "./SpoiledBottomBar.vue?vue&type=template&id=f4ef8992&scoped=true&"
import script from "./SpoiledBottomBar.vue?vue&type=script&lang=js&"
export * from "./SpoiledBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledBottomBar.vue?vue&type=style&index=0&id=f4ef8992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ef8992",
  null
  
)

export default component.exports